import VSnackbar from './VSnackbar';
export { VSnackbar };
export default VSnackbar;
//# sourceMappingURL=index.js.map